document.addEventListener("DOMContentLoaded", function () {
    // Check if the wrapping element exists and has the correct data-product-id
    const productContainer = document.querySelector(".mankai-product-container");
    
    if (productContainer && productContainer.getAttribute("data-product-id") === "7362364506179") {
        // Select all the label elements inside the swatches list
        const labels = document.querySelectorAll(".swatches .label-swatch");
        
        // Select all the information cards
        const infoCards = document.querySelectorAll(".multicolumn-card__info");

        // Loop through both NodeLists and replace text content
        labels.forEach((label, index) => {
            if (infoCards[index]) {
                label.innerHTML = infoCards[index].innerHTML; // Copy the content including HTML structure
            }
        });

        // Find the parent .shopify-section of the .multicolumn-card and hide it
        const shopifySection = document.querySelector(".multicolumn-card")?.closest(".shopify-section");
        if (shopifySection) {
            shopifySection.style.display = "none";
        }
    }

    
	/* Anchors scroller */
    const { innerWidth: width, innerHeight: height } = window;
    document.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener('click', e => {
            const href = link.getAttribute('href');
            if (!href || href === '#') return; // ignore empty anchors

            const target = document.querySelector(href);
            if (!target) return;

            e.preventDefault();

            const topPadding = (window.innerWidth < 768) ? 100 : 70;
            const targetY = target.getBoundingClientRect().top + window.pageYOffset - topPadding;

            // Smooth scroll to the target position
            window.scrollTo({ top: targetY, behavior: 'smooth' });
        });
    });


    /* Mankai(R) mark: inserts an empty .copyright-symbol span (® drawn via CSS) right
       after "Mankai", anywhere text is rendered. "plant" is added after the mark
       whenever it isn't already there, e.g.:
         "Mankai plant"  -> "Mankai[R] plant"
         "Mankai"        -> "Mankai[R] plant"
         "Mankai's"      -> "Mankai[R] plant's" */
    (function () {
        /* The Blood Sugar LP copy already carries its own ® marks */
        if (document.body.classList.contains('template-mankai-blood-sugar-lp')) return;

        const MANKAI_RE = /\b(Mankai)(['’]s)?(\s+plant)?(?![-\w])/gi;
        const SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'NOSCRIPT']);

        function markMankaiPlant(root) {
            const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
                acceptNode(node) {
                    if (!node.nodeValue || !MANKAI_RE.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
                    MANKAI_RE.lastIndex = 0;
                    const parent = node.parentElement;
                    if (!parent || SKIP_TAGS.has(parent.tagName) || parent.isContentEditable) return NodeFilter.FILTER_REJECT;
                    if (parent.closest('.mankai-announcement-bar')) return NodeFilter.FILTER_REJECT;
                    return NodeFilter.FILTER_ACCEPT;
                }
            });

            const textNodes = [];
            let node;
            while ((node = walker.nextNode())) textNodes.push(node);

            textNodes.forEach((textNode) => {
                const text = textNode.nodeValue;
                const fragment = document.createDocumentFragment();
                let lastIndex = 0;
                let match;
                MANKAI_RE.lastIndex = 0;
                while ((match = MANKAI_RE.exec(text))) {
                    const mankaiWord = match[1];
                    const possessive = match[2] || '';
                    const plantPart = match[3] || (mankaiWord === mankaiWord.toUpperCase() ? ' PLANT' : ' plant');
                    fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index) + mankaiWord));
                    const mark = document.createElement('span');
                    mark.className = 'copyright-symbol';
                    fragment.appendChild(mark);
                    fragment.appendChild(document.createTextNode(plantPart + possessive));
                    lastIndex = match.index + match[0].length;
                }
                fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
                textNode.parentNode.replaceChild(fragment, textNode);
            });
        }

        markMankaiPlant(document.body);

        const observer = new MutationObserver((mutations) => {
            observer.disconnect();
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((addedNode) => {
                    if (addedNode.nodeType === Node.ELEMENT_NODE) markMankaiPlant(addedNode);
                });
            });
            observer.observe(document.body, { childList: true, subtree: true });
        });
        observer.observe(document.body, { childList: true, subtree: true });
    })();

});
